import { render, staticRenderFns } from "./ReviewSidebar.vue?vue&type=template&id=3d07d03c&scoped=true&"
import script from "./ReviewSidebar.vue?vue&type=script&lang=ts&"
export * from "./ReviewSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewSidebar.vue?vue&type=style&index=0&id=3d07d03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d07d03c",
  null
  
)

export default component.exports